import React from "react";
import { FaCheck, FaSpinner } from "react-icons/fa";

const STEP_LABELS = {
  1: { text: "Fetching traffic & session data", icon: "📊" },
  2: { text: "Analyzing traffic sources", icon: "🌐" },
  3: { text: "Scanning page performance", icon: "📄" },
  4: { text: "Processing nudge engagement", icon: "💡" },
  5: { text: "Reading user journey paths", icon: "🗺️" },
  6: { text: "Analyzing heatmap clicks", icon: "🔥" },
  7: { text: "Checking visitor retention", icon: "🔄" },
  8: { text: "Building device breakdown", icon: "📱" },
  9: { text: "Detecting capabilities", icon: "⚡" },
  10: { text: "Generating AI insights", icon: "🤖" },
  11: { text: "Done!", icon: "✅" },
};

const ProgressSteps = ({ currentStep, currentMessage }) => {
  if (!currentStep) return null;

  // Show only completed steps + current step
  const stepsToShow = [];
  for (let i = 1; i <= Math.min(currentStep, 11); i++) {
    const stepInfo = STEP_LABELS[i] || { text: `Step ${i}`, icon: "⏳" };
    stepsToShow.push({
      step: i,
      ...stepInfo,
      isCompleted: i < currentStep,
      isCurrent: i === currentStep,
    });
  }

  return (
    <div className="py-3 px-1">
      <div className="space-y-2">
        {stepsToShow.map((s) => (
          <div
            key={s.step}
            className={`flex items-center gap-2.5 text-sm transition-all duration-300 ${
              s.isCompleted
                ? "text-slate-400"
                : s.isCurrent
                ? "text-indigo-600 dark:text-indigo-400 font-medium"
                : "text-slate-300"
            }`}
          >
            {/* Status icon */}
            <span className="w-5 text-center shrink-0">
              {s.isCompleted ? (
                <FaCheck className="text-emerald-500 text-xs" />
              ) : s.isCurrent ? (
                <FaSpinner className="animate-spin text-indigo-500 text-xs" />
              ) : (
                <span className="text-slate-300">○</span>
              )}
            </span>
            {/* Step emoji */}
            <span className="text-sm">{s.icon}</span>
            {/* Step text */}
            <span className={s.isCompleted ? "opacity-50" : ""}>
              {s.isCurrent ? currentMessage || s.text : s.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressSteps;
